import React, { useContext, useEffect, useState } from "react";
import { Link, Navigate, resolvePath } from "react-router-dom";
import LayoutMain from '../Dashboard/LayoutMain/LayoutMain';
import AppContext from '../../store/AppContext';
import { API_URL_MAIN } from '../../constants/driveglobalfilterinitalstates';
import useHttp from '../../hook/use-http';
import WaterMark from "../Dashboard/DashboardMain/WaterMark";
import { useNavigate } from 'react-router-dom';
import value from "wink-statistics/src/accessor";
//import pptpage from './myPPT_02082023.pptx';
// import pptpage from '../../../src/to_be_deleted/myPPT_02082023.pptx';
import DatePicker from "react-datepicker";
import moment from 'moment';
import DashboardMain from '../Dashboard/DashboardMain/DashboardMain';
// const   { spawn } = require('child_process').spawn;
// import { PyScript } from "../components/pyscript"
import getMobileOperatingSystem from '../../util/getMobileOperatingSystem';
import getOperatingSystem from '../../util/getOperatingSystem';


let search_count = 0
let download_count = 0

export default function Workbench(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);
  const navigate = useNavigate();
  const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  const [changedColumn, setChangedColumn] = useState("");
  const [columnfilters, setcolumnfilters] = useState([]);
  const [startDate, setStartDate] = useState([]);
  const [endDate, setEndDate] = useState([]);
  const abc = (data) => {
    console.log("-----", data)

  }

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "Report Automation"
      }
    })
    // fetchData({ url:"http://172.31.154.222/home/hadoop/to_be_deleted/react_python.py",body:{} },abc)
    // const log1 = fetchData({
    //   url: "http://172.31.154.222/home/hadoop/to_be_deleted/react_python.py?'2023-08-01', '2023-08-05'", body: {
    //     page_name: "workbench"
    //   }
    // })
    // console.log("log",log)
  }, []);


  useEffect(() => {
    console.log("hited workbench");
  }, []);
  const startDateChanged = (date) => {
    console.log(date);
    let stdate = new Date(date);
    let startdate = stdate.getFullYear() + '-' + (stdate.getMonth() + 1) + '-' + stdate.getDate()
    console.log("start date", startdate);
    setStartDate(startdate)

    //setStartDate(date);
    let sDate = "startDate";
    setChangedColumn("startDate");
    setFilterData((prestate) => { return { ...filterdata, [sDate]: date } })
    if (columnfilters.indexOf("START_DATE") == -1) {
      setcolumnfilters([...columnfilters, "START_DATE"]);
    }

  }

  const endDateChanged = (date) => {
    console.log(date);
    let etdate = new Date(date);
    let enddate = etdate.getFullYear() + '-' + (etdate.getMonth() + 1) + '-' + etdate.getDate()
    console.log("start date", enddate);
    // setStartDate(enddate)
    setEndDate(enddate)
    // setEndDate(date);
    let eDate = "endDate";
    setChangedColumn("endDate");
    setFilterData((prestate) => { return { ...filterdata, [eDate]: date } })
    if (columnfilters.indexOf("END_DATE") == -1) {
      setcolumnfilters([...columnfilters, "END_DATE"]);
    }
  }
  const [arraySub, setArraySub] = useState([])
  const arraySub1 = [
    { sub_id: 1, sub_name: "DA1" },
    { sub_id: 2, sub_name: "DA2" },
    { sub_id: 3, sub_name: "DA3" }
  ]
  const arraySub2 = [
    { sub_id: 1, sub_name: "FA1" },
    { sub_id: 2, sub_name: "FA2" },
    { sub_id: 3, sub_name: "FA3" }
  ]
  const arraySub3 = [
    { sub_id: 1, sub_name: "CA1" },
    { sub_id: 2, sub_name: "CA2" },
    { sub_id: 3, sub_name: "CA3" }
  ]
  const getDashboardId = (e) => {
    if (e.target.value === "1") {
      setArraySub(arraySub1)
    } else if (e.target.value === "2") {
      setArraySub(arraySub2)
    } else {
      setArraySub(arraySub3)
    }
    // var optionElement = e.target[e.target.selectedIndex].getAttribute('data-id')
    // console.log(optionElement, "key");
  }
  const [isppt, setIsPpt] = useState(false)
  const onsubmit = async () => {
    // const statResult = await stat('../../../src/to_be_deleted/myPPT_02082023.pptx');
    // console.log('file size: ' + statResult.size);
    // let fileInfo = getFileInfo('../../../src/to_be_deleted/myPPT_02082023.pptx');
    // console.log('file size:---------> ' + fileInfo.size);
    //   const python_code = `
    //   print('Hello Test')
    // `;

    // const pyodide = window.pyodide
    // pyodide.runPython(python_code);

    // console.log("process.env.PUBLIC_URL")
    // const PythonShell=require('python-shell');
    // PythonShell.run('d:\\test.py', undefined, function (err: any)              {
    //   if (err) throw err;
    //   console.log('finished');
    // });
    // const {spawn} =require("child_process").spawn;
    // console.log("spwan",spawn)
    // const spawn = childProcess.spawn;
    //const pythonProcess = spawn('python', ['D:\\site\\web-app\\src\\python\\teste.py', "teste", "arg2"]);

    // pythonProcess.stdout.on('data', data => {
    //   console.log(data.toString());
    // });

    // pythonProcess.stderr.on('data', data => {
    //   console.error(data.toString());
    // });

    // pythonProcess.on('close', code => {
    //   console.log(`Script completed with code ${code}`);
    // });
    // window.open("C:\\Users\\bipins.ttl\\OneDrive - TATA MOTORS LTD\\Download\\myPPT_02082023.pptx")
    try {
      const result = await fetch("https://geolocation-db.com/json/", {
        method: 'GET',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        },
        mode: 'cors'
      });
      const result__ = await result.json();
      let device_id = getMobileOperatingSystem();
      let os_sys = getOperatingSystem(window);
      console.log(device_id);


      fetchData({
        url: API_URL_MAIN + "auth/python", body: { ip_address: result__.IPv4, device_id, os_sys, startDate: startDate, endDate: endDate, page_name: "Report Automation", search_count: "1", download_count: "0" }
      }, startDate, endDate)
    } catch (error) {
      console.log(error)
    }
  }
  const onDownload = async () => {
    try {
      const result = await fetch("https://geolocation-db.com/json/", {
        method: 'GET',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        },
        mode: 'cors'
      });
      const result__ = await result.json();
      let device_id = getMobileOperatingSystem();
      let os_sys = getOperatingSystem(window);
      console.log(device_id);

      fetchData({
        url: API_URL_MAIN + "auth/python", body: { ip_address: result__.IPv4, device_id, os_sys, startDate: startDate, endDate: endDate, page_name: "Report Automation", search_count: "0", download_count: "1" }
      }, startDate, endDate)
    } catch (error) {
      console.log(error)
    }
    setIsPpt(true)
  }
  return (
    <>
      {/* <LayoutMain> */}
      <DashboardMain>

        <div className="row" style={{ marginTop: "9em", marginLeft: "1em" }}>
          <WaterMark />
          <div className="col-md-2">
            {/* <select title="select dashboard" class="form-select" onChange={(e) => getDashboardId(e)}>
              <option>Select...</option>
              <option value="1" key="1">Drive Analysis</option>
              <option value="2" key="2">Fault Analysis</option>
              <option value="3" key="3">Charging Analysis</option>
            </select> */}
            <label htmlFor="exampleFormControlInput1" className="select_col_title">Start Date</label>
            <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2022-07-01T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata.startDate} onChange={startDateChanged} />

          </div>

          <div className="col-md-2">
            {/* <select title="select ouery" class="form-select">
              <option>Select...</option>
              {
                arraySub.map((sss, index) => (
                  <option value={sss.sub_id} key={index}>{sss.sub_name}</option>
                ))
              }
            </select> */}
            <label htmlFor="exampleFormControlInput1" className="select_col_title">End Date</label>
            <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2022-07-01T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata.endDate} onChange={endDateChanged} />

          </div>
          <div className="col-lg-2 col-md-6 col-sm-12">
            {/* <div className="mt-4"> */}
            <label htmlFor className="col-md-3" />
            {/* <a href="\\Users\\bipins.ttl\\OneDrive - TATA MOTORS LTD\\Download\\myPPT_02082023.pptx"> */}
            <button className="form-control btn btn-primary" onClick={onsubmit}>Search</button>
            {/* </a> */}
          </div>
          <div className="col-lg-2 col-md-6 col-sm-12">
            <label htmlFor className="col-md-3" />
            <button className="form-control btn btn-primary" onClick={onDownload}>Download</button>
          </div>
          {/* </div> */}
          {/* { isppt ?
                  <iframe src={pptpage} style={{ marginTop: "7%" }} frameborder="0" height="500em" width="100%"></iframe>

        :<></>} */}
        </div>

      </DashboardMain>
      {/* </LayoutMain> */}
    </>
  );
}
